import { useEffect, useState } from 'react';

function getMatchMedia(query: string): MediaQueryList | null {
  if (globalThis.window === undefined) {
    return null;
  }
  return globalThis.window.matchMedia(query);
}

/**
 * Subscribe to a CSS media query and return whether it currently matches.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => getMatchMedia(query)?.matches ?? false);

  useEffect(() => {
    const mediaQuery = getMatchMedia(query);
    if (!mediaQuery) {
      return undefined;
    }

    const handleChange = () => setMatches(mediaQuery.matches);

    handleChange();
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
}

/** Desktop layout with fixed sidebars (>= 1024px). */
export function useIsDesktopLayout(): boolean {
  return useMediaQuery('(min-width: 1024px)');
}

/** Phone layout (<= 639px). */
export function useIsMobileLayout(): boolean {
  return useMediaQuery('(max-width: 639px)');
}
